<script lang="ts">
    import BackIcon from "@icons/Back.svelte";

    interface Props {
        onclick: () => void;
    }

    let { onclick }: Props = $props();
</script>

<button class="icon" {onclick}>
    <BackIcon />
</button>
